import * as api from '../../api/dashboards';
import { asyncAction } from '../common';

export const updateMode = (dashboard) => ({
  type: 'COMPOSE_DASHBOARD',
  dashboard,
});

export const copyMode = (dashboard) => ({
  type: 'COPY_DASHBOARD',
  dashboard,
});

export const createMode = () => ({
  type: 'CREATE_DASHBOARD_MODE',
});

export const resetDashboardMode = () => ({
  type: 'RESET_DASHBOARD_MODE',
});

export const resetDashboardCompose = () => ({
  type: 'RESET_DASHBOARD',
});

export const setUpdateTime = () => ({
  type: 'SET_DASHBOARD_UPDATE_TIME',
});

export const setEditingDashboard = (dashboard) => ({
  type: 'SET_EDITING_DASHBOARD',
  dashboard,
});

export const toggleEditDashboard = () => ({
  type: 'TOGGLE_EDIT_DASHBOARD',
});

export const executeTemplateQuery = (
  tenantId,
  dashboardId,
  templateId,
  queryId,
  button = false
) => ({
  type: 'START_EXECUTE_TEMPLATE_QUERY',
  tenantId,
  dashboardId,
  templateId,
  queryId,
  button,
});

export const setDashboardName = (name) => ({
  type: 'SET_DASHBOARD_NAME',
  name,
});

export const expandDashboard = (dashboardId) => ({
  type: 'SET_DASHBOARD_EXPAND',
  dashboardId,
});

export const selectDashboard = (dashboardId) => ({
  type: 'SELECT_DASHBOARD',
  dashboard: dashboardId,
});

export const setDashboardUnit = () => ({
  type: 'SET_DASHBOARD_UNIT',
});

export const setDashboardUnitType = (id, unitType) => ({
  type: 'SET_DASHBOARD_UNIT_TYPE',
  id,
  unitType,
});

export const setDashboardUnitName = (id, unitName) => ({
  type: 'SET_DASHBOARD_UNIT_NAME',
  id,
  unitName,
});

export const deleteDashboardUnit = (id) => ({
  type: 'DELETE_DASHBOARD_UNIT',
  id,
});

export const changeSizeDashboardUnit = (id) => ({
  type: 'CHANGE_SIZE_DASHBOARD_UNIT',
  id,
});

export const resetDashboardUnit = (id) => ({
  type: 'RESET_DASHBOARD_UNIT',
  id,
});

export const setUnitError = (id) => ({
  type: 'EXECUTE_DASHBOARD_UNIT_QUERIES_ERROR',
  id,
});

export const setMetaInfForRevenue = (unitId, paths) => ({
  type: 'SET_META_INFO_FOR_REVENUE',
  unitId,
  paths,
});

export const executeDashboardUnitQueriesStart = (unit, executeId) => ({
  type: 'EXECUTE_DASHBOARD_UNIT_QUERIES_START',
  unit,
  executeId,
});

export const setUnits = (units) => ({
  type: 'SET_DASHBOARD_UNITS',
  units,
});

export const setRequestCanceled = (unitId) => ({
  type: 'CANCEL_DASHBOARD_UNIT_REQUEST',
  unitId,
});

export const errorHandlerUnitsQueries = (id) => (dispatch) => dispatch(setUnitError(id));

export const fetchDashboards = () => asyncAction('FETCH_DASHBOARDS', api.getDashboards());

export const saveDashboard = () => asyncAction('SAVE_DASHBOARD', api.createDashboard());

export const updateDashboard = () => asyncAction('UPDATE_DASHBOARD', api.updateDashboard());

export const deleteDashboard = (id) => asyncAction('DELETE_DASHBOARD', api.deleteDashboard(id));
